<template>
    <q-dialog v-model="confirm" persistent>
      <q-card>
        <q-card-section class="flex flex-center" >
          <q-icon name="error" size="md" class="text-red text-center" />
        </q-card-section>
        <q-card-section class="row items-center">
          <p class="q-ml-sm text-center">Are you sure you want to cancel this subscription?</p>
        </q-card-section>

        <q-card-actions align="center">
          <q-btn flat label="Close" color="red" v-close-popup />
          <q-btn label="Yes, I'm sure" color="red" @click="cancel()" v-close-popup /> 
        </q-card-actions>
      </q-card>
    </q-dialog>
</template>
<script>
import { useQuasar } from 'quasar'
import { inject, ref } from '@vue/runtime-core'
export default {
  props: ['subscription', 'confirm'],
  setup(props, context) {
    const $q = useQuasar()
    const axios = inject('axios')
    const cancel = () => {
      axios.get(`${process.env.VUE_APP_URL}/paypal/subscription/cancel/${props.subscription}`)
      .then((resp)=>{
        $q.notify({
          message: 'Success!',
          caption: 'Your subscription was successfully cancelled.',
          color: 'positive'
        })
        dialog.value = false
        context.emit('cancelled')
      })
      .catch((err) => {
        $q.notify({
          message: 'An error has ocurred!',
          caption: 'An error ocurred when updating the current plan data to your place. Wait a few moments and try again.',
          color: 'negative'
        })
      })
    }

    return {cancel}
  },
}
</script>
